import { linkify } from '@/helpers/dataHelper';
import { useState } from 'react';

const ReadMore = ({ text, className = '', style = {} }) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <>
      <p className={`${className || ''} m-0 `} style={style as any}>
        {isReadMore ? text?.slice(0, 150) : text}
        <a
          onClick={toggleReadMore}
          className={`read-or-hide ml-1 font-weight-normal font-size-sm`}
        >
          {isReadMore ? (
            text?.length >= 150 ? (
              <>
                ...<u>read more</u>
              </>
            ) : (
              ''
            )
          ) : text?.length >= 150 ? (
            <u>read less </u>
          ) : (
            ''
          )}
        </a>
      </p>
    </>
  );
};

export default ReadMore;

export const InnerHtmlReadMore = ({
  text,
  className = '',
  style = {},
  size = 150,
}) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <>
      <p className={`${className || ''}`} style={style as any}>
        {isReadMore ? (
          <div
            className="pb-2 gradient-text-style"
            dangerouslySetInnerHTML={{ __html: linkify(text?.slice(0, size)) }}
          />
        ) : (
          <div
            className="pb-2"
            dangerouslySetInnerHTML={{ __html: linkify(text) }}
          />
        )}
        <a
          onClick={toggleReadMore}
          className={`read-or-hide ml-1 font-weight-normal font-size-sm`}
          style={{
            display: 'inherit',
          }}
        >
          {isReadMore ? (
            text?.length >= 150 ? (
              <>
                ...<u className="font-weight-bold ">Read more</u>
              </>
            ) : (
              ''
            )
          ) : text?.length >= 150 ? (
            <u className="font-weight-bold ">Read less </u>
          ) : (
            ''
          )}
        </a>
      </p>
    </>
  );
};

  export const newlineText = (text: string) => {
    const newText = text?.split('\n').map((str) => <p>{str}</p>);
    return newText;
  };